import TabViewModel from "../../../../Lib/Fs.SmartClient.Client/TabViewModel";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import ResetPasswordTokenRequest from "../../Scripts/AppServiceContract/ResetPasswordTokenRequest";
import ChangePasswordUpdateRequest from "../../Scripts/AppServiceContract/ChangePasswordUpdateRequest";
import ResetPasswordUpdateRequest from "../../Scripts/AppServiceContract/ResetPasswordUpdateRequest";
import { useView, autoinject, Container } from 'aurelia-framework'
import { OpenIdConnect, OpenIdConnectRoles } from "aurelia-open-id-connect";
import ChangePasswordAppService from "../../Scripts/AppServiceContract/ChangePasswordAppService";
import { User } from "oidc-client";
import { fs } from "../../../../Config/FsConfig";
import PasswordRequirementsDisplayData from "../../Scripts/AppServiceContract/PasswordRequirementsDisplayData";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./ChangePasswordView.html"))
export default class ChangePasswordVM extends TabViewModel {

    public OpenIdConnect: OpenIdConnect;
    constructor(openIdConnect: OpenIdConnect) {
        super();
        this.OpenIdConnect = openIdConnect;
    }

    public IsFromLogin: boolean = false;
    public ResourceId: string;
    public TokenKey: string;

    public OldPassword: string;
    public NewPassword: string;
    public ConfirmPassword: string;

    public User: User;
    public PasswordRequirementDisplayData: PasswordRequirementsDisplayData;

    get IsShowPasswordRequirements() {
        return (fs.Config.IsShowPasswordRequirements && (
            this.PasswordRequirementDisplayData.MinLength > 0 ||
            this.PasswordRequirementDisplayData.MaxNeighboringCharacter > 0 ||
            this.PasswordRequirementDisplayData.MaxRepeatSameCharacter > 0 ||
            this.PasswordRequirementDisplayData.MinUniqueCharacters > 0 ||
            this.PasswordRequirementDisplayData.RequireDigit == true ||
            this.PasswordRequirementDisplayData.RequireLowercase == true ||
            this.PasswordRequirementDisplayData.RequirePunctuation == true ||
            this.PasswordRequirementDisplayData.RequireUppercase == true
            ));
    }
    activate(params, route) {

        var self = this;

        if (typeof route != "undefined") {
            this.IsFromLogin = route.settings.IsFromLogin;
            if (!this.IsFromLogin) {
                this.ResourceId = params.ResourceId;
                this.TokenKey = params.TokenNo;

                var request = new ResetPasswordTokenRequest();
                request.ResourceUID = this.ResourceId;
                request.TokenKey = this.TokenKey;

                var service = this.container.get(ChangePasswordAppService) as ChangePasswordAppService;
                service.CheckToken(request).done(function (result) {
                    if (!result) {
                        window.history.back();
                    }
                }).fail(function (error) {
                    FsUtility.AlertErrorMessage(error);
                    window.history.back();
                });
            } else {
                this.OpenIdConnect.getUser().then(function (result) {
                    self.User = result;
                    if (self.User == null) {
                        window.history.back();
                    }
                });
            }
        }
        this.LoadPasswordRequirementDisplayData();
    }

    Submit() {
        var self = this;
        var service = this.container.get(ChangePasswordAppService) as ChangePasswordAppService;
        if (this.IsFromLogin) {
            var request = new ChangePasswordUpdateRequest();
            request.OldPassword = this.OldPassword;
            request.NewPassword = this.NewPassword;
            request.ConfirmPassword = this.ConfirmPassword;
            service.ChangePassword(request)
                .done(function () {
                    self.PageRedirect();
                }).fail((error) => {
                    FsUtility.AlertErrorMessage(error);
                });
        } else {
            var resetRequest = new ResetPasswordUpdateRequest();
            resetRequest.TokenKey = this.TokenKey;
            resetRequest.UserUID = this.ResourceId;
            resetRequest.NewPassword = this.NewPassword;
            resetRequest.ConfirmPassword = this.ConfirmPassword;
            service.ResetPassword(resetRequest).done(function () {
                    self.PageRedirect();
            }).fail((error) => {
                FsUtility.AlertErrorMessage(error);
            });
        }
    }

    LoadPasswordRequirementDisplayData() {
        var self = this;
        var service = this.container.get(ChangePasswordAppService) as ChangePasswordAppService;
        service.LoadPasswordRequirementsData().done((result) => {
            this.PasswordRequirementDisplayData = result;
        }).fail((error) => {
            FsUtility.AlertErrorMessage(error);
        });
    }

    Cancel() {
        window.history.back();
    }

  PageRedirect() {
    window.location.href = fs.Config.ClientBaseUrl + "Modules/Core/ChangePasswordPage#RedirectSuccess";
    }
}
